/*------------------------------------------------
// File Name:HSM_UNIONPAY.js
// File Description:HSM_UNIONPAY store方法
// Author:zxl
// Create Time:2022/07/15 14:28:44
//------------------------------------------------*/

import {
  GetHSM_UNIONPAYListByPage,
  GetPayState,
  SetBackState,
} from "@/api/pdm/unionpay";

import msg from "@/config/notify";
import dlg from "@/config/dialog";
//import { toRaw } from "vue";

export const HsmUnionpay = {
  namespaced: true,
  state: {
    HsmUnionpayList: [],
    HsmUnionpayListLoading: false,
    HsmUnionpayEntity: null,
    HsmUnionpayShowDlg: false,
  },
  mutations: {
    setHsmUnionpayList(state, dataList) {
      state.HsmUnionpayList = [...dataList];
    },
    setHsmUnionpayListLoading(state, visible) {
      state.HsmUnionpayListLoading = visible;
    },
    setHsmUnionpayShowDlg(state, visible) {
      state.HsmUnionpayShowDlg = visible;
    },
    setHsmUnionpayEntity(state, entity) {
      state.HsmUnionpayEntity = entity;
    },
  },
  actions: {
    //分页加载列表
    actGetHsmUnionpayListByPage({ commit }, parm) {
      return new Promise((resolve) => {
        commit("setHsmUnionpayListLoading", true);
        GetHSM_UNIONPAYListByPage(parm)
          .then((res) => {
            if (res.Code == 0) {
              commit("setHsmUnionpayList", res.Data);
              //msg.success(res.Message)
              resolve(res);
            } else {
              dlg.alert(res.Message);
              // msg.error(res.Message)
            }
          })
          .finally(() => {
            commit("setHsmUnionpayListLoading", false);
          });
      }).catch((err) => {
        console.log(err);
      });
    },
    //大后台-查询订单状态
    actGetPayState({ commit }, parm) {
      return new Promise((resolve) => {
        commit("setHsmUnionpayListLoading", true);
        GetPayState(parm)
          .then((res) => {
            if (res.Code == 0) {
              msg.success(res.Message);
              resolve(res);
            } else {
              dlg.alert(res.Message);
              resolve(res);
            }
          })
          .finally(() => {
            commit("setHsmUnionpayListLoading", false);
          });
      }).catch((err) => {
        console.log(err);
      });
    },
    //大后台-退款
    actSetBackState({ commit }, parm) {
      return new Promise((resolve) => {
        dlg.confirm("是否确定退款？").onOk(() => {
          commit("setHsmUnionpayListLoading", true);
          SetBackState(parm)
            .then((res) => {
              if (res.Code == 0) {
                dlg.alert(res.Message);
                resolve(res);
              } else {
                dlg.alert(res.Message);
                resolve(res);
              }
            })
            .finally(() => {
              commit("setHsmUnionpayListLoading", false);
            });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
  },
};
